import React from 'react'
import './section.scss'

const Section = ({ theme, id, className, children }) => {
	return (
		<section
			key={theme}
			className={`section${theme !== undefined ? ` section-${theme}` : ''}`}
			id={id !== undefined ? id : ''}
		>
			<div
				className={`section_inner ${
					className !== undefined ? `${className}` : ''
				}`}
			>
				{children}
			</div>
		</section>
	)
}

export default Section
